"use client";

import { Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { Icon } from "@/components/ui/icon";
import { whyChooseUs } from "@/lib/data/homepage";

/**
 * Why Choose Us — Track-record timeline. 6 reasons as connected
 * timeline nodes with year markers and mini-stat callouts.
 */
export function WhyChooseUs() {
  const yearMarkers = ["2011", "2014", "2017", "2020", "2023", "2026"];
  const accents = [
    "var(--color-crimson)",
    "var(--color-purple)",
    "var(--color-cyan)",
    "var(--color-emerald)",
    "var(--color-amber)",
    "var(--color-coral)",
  ];
  return (
    <section id="why-choose-us" className="relative section-pad">
      <Container>
        <Reveal className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass eyebrow-tiny text-[var(--color-gold)]">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--color-gold)]" />
            Why Choose Us
          </span>
          <h2 className="mt-6">
            The Perception X2 Decision
          </h2>
        </Reveal>

        {/* Timeline */}
        <Reveal className="mb-10">
          <div className="relative max-w-3xl mx-auto">
            <div className="absolute left-0 right-0 top-1/2 h-px bg-gradient-to-r from-transparent via-[var(--color-gold)] to-transparent opacity-30" />
            <div className="grid grid-cols-6 gap-2">
              {yearMarkers.map((y, i) => (
                <div key={y} className="text-center">
                  <div
                    className="mx-auto h-3 w-3 rounded-full mb-2"
                    style={{
                      background: accents[i],
                      boxShadow: `0 0 12px ${accents[i]}`,
                    }}
                  />
                  <div className="eyebrow-tiny text-[rgb(var(--fg-subtle))] font-semibold font-mono-num">
                    {y}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {whyChooseUs.map((w, i) => (
            <Reveal key={w.title} delay={i * 60}>
              <div
                className="rounded-2xl glass p-5 h-full relative overflow-hidden card-glow"
                style={{ ["--glow" as string]: accents[i] }}
              >
                <div className="flex items-center gap-3 mb-3">
                  <div
                    className="grid place-items-center h-9 w-9 rounded-lg shrink-0"
                    style={{
                      background: `color-mix(in oklch, ${accents[i]} 18%, transparent)`,
                      boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accents[i]} 35%, transparent)`,
                    }}
                  >
                    <Icon name={w.icon} className="h-4 w-4" style={{ color: accents[i] }} />
                  </div>
                  <h3>{w.title}</h3>
                </div>
                <p className="text-body-xs leading-relaxed text-[rgb(var(--fg-muted))]">{w.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}
